import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Spinner,
  Center,
  VStack,
  Empty,
  EmptyHeadline,
  EmptyDescription,
  EmptyDrawerIcon,
} from '@frontend/components';

import TaskListItem from '../components/TaskListItem';
import { dashboardListInit } from './data/actions';
import { getIsFetchingTasks, getTasks } from './data/reducer';

const Dashboard = () => {
  const isFetchingTasks = useSelector(getIsFetchingTasks);
  const tasks = useSelector(getTasks);
  const dispatch = useDispatch();
  const init = useCallback(() => {
    dispatch(dashboardListInit.request());
  }, [dispatch]);
  useEffect(() => {
    init();
  }, [init]);

  return (
    <VStack
      flex="1 1 100%"
      overflowY="auto"
      p={0}
      spacing={0}
      alignItems="stretch"
    >
      {isFetchingTasks ? (
        <Center p={2}>
          <Spinner size="xl" />
        </Center>
      ) : tasks.length == 0 ? (
        <Center p={2}>
          <Empty>
            <EmptyDrawerIcon />
            <EmptyHeadline>No tasks</EmptyHeadline>
            <EmptyDescription>
              You don&apos;t have any tasks assigned to you.
            </EmptyDescription>
          </Empty>
        </Center>
      ) : (
        tasks.map((task) => <TaskListItem key={task.id} task={task} />)
      )}
    </VStack>
  );
};

export default Dashboard;
